import * as Types from '../../../schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminPromotionReleasesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.PromotionReleaseFilterQuery>;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type AdminPromotionReleasesQuery = { __typename?: 'Query', adminPromotionReleases?: { __typename?: 'PromotionReleasePageGraphqlType', totalCount: number, edges: Array<{ __typename?: 'PaginatedPromotionReleaseGraphqlTypeEdge', node: { __typename?: 'PromotionReleaseGraphqlType', id: number, updatedAt: string, createdAt: string, releaseStatus: Types.EPromotionReleaseStatus, scheduledReleaseAt?: string | null, confirmedOrderAt?: string | null, completedReleaseAt?: string | null, note?: string | null, zipCode?: string | null, receiverName: string, receiverPhoneNumber: string, receiverAddress: string, receiverDetailAddress?: string | null, deliveryMessage?: string | null, releaseCode: string, promotion: { __typename?: 'PromotionGraphqlType', id: number, promotionType: Types.EPromotionType, orderCode?: string | null, isDeliveryFee: boolean, deliveryFeeBearer?: Types.ECostBearer | null, deliveryFee?: number | null, sampleStatus: Types.ESampleStatus, vendor: { __typename?: 'VendorGraphqlType', id: number, name: string }, manager: { __typename?: 'ManagerGraphqlType', id: number, name: string }, market?: { __typename?: 'MarketGraphqlType', id: number, name: string } | null }, promotionProducts: Array<{ __typename?: 'PromotionProductGraphqlType', customPromotionProductName?: string | null, setCount: number, isFreeProvided: boolean, isPrepayment?: boolean | null, isSellerBearing?: boolean | null, isWiredBearing?: boolean | null, sellerBearingCost?: number | null, wiredBearingCost?: number | null, promotionItems: Array<{ __typename?: 'PromotionItemGraphqlType', id: number, originalItem?: { __typename?: 'ItemGraphqlType', id: number, name: string } | null }>, originalProduct?: { __typename?: 'ProductGraphqlType', name: string } | null, originalProductGroup?: { __typename?: 'ProductGroupGraphqlType', id: number, name: string } | null, delivery?: { __typename?: 'PromotionReleaseProductRelationGraphqlType', id: number, trackingNumber?: string | null, deliveryCompanyId?: number | null, promotionProductId: number } | null }>, seller?: { __typename?: 'SellerGraphqlType', id: number, name: string } | null } }> } | null };

export type AdminPromotionReleaseQueryVariables = Types.Exact<{
  adminPromotionReleaseId: Types.Scalars['Int']['input'];
}>;


export type AdminPromotionReleaseQuery = { __typename?: 'Query', adminPromotionRelease: { __typename?: 'PromotionReleaseGraphqlType', id: number, releaseCode: string, releaseStatus: Types.EPromotionReleaseStatus, sellerSettlementInfoId?: number | null, zipCode?: string | null, receiverName: string, receiverPhoneNumber: string, receiverAddress: string, receiverDetailAddress?: string | null, deliveryMessage?: string | null, scheduledReleaseAt?: string | null, note?: string | null, promotion: { __typename?: 'PromotionGraphqlType', id: number, orderCode?: string | null, promotionType: Types.EPromotionType, sampleStatus: Types.ESampleStatus, isDeliveryFee: boolean, deliveryFee?: number | null, deliveryFeeBearer?: Types.ECostBearer | null, deliveryFeeSettlementPrice?: number | null, deliveryFeeSettlementTarget?: Types.ESettlementTarget | null, market?: { __typename?: 'MarketGraphqlType', id: number, name: string, productGroups: Array<{ __typename?: 'ProductGroupGraphqlType', id: number, name: string, products: Array<{ __typename?: 'ProductGraphqlType', id: number, name: string, useType: Types.EProductUseType, items?: Array<{ __typename?: 'ItemGraphqlType', id: number, name: string }> | null }> }> } | null, marketEvent?: { __typename?: 'MarketEventGraphqlType', id: number, type: Types.EMarketEventType, count?: number | null } | null, promotionReleases: Array<{ __typename?: 'PromotionReleaseGraphqlType', id: number, receiverName: string, receiverPhoneNumber: string, zipCode?: string | null, receiverAddress: string, deliveryMessage?: string | null, releaseStatus: Types.EPromotionReleaseStatus }> }, seller?: { __typename?: 'SellerGraphqlType', id: number, name: string, phoneNumber: string, settlementInfos: Array<{ __typename?: 'SellerSettlementInfoGraphqlType', id: number, type: Types.ESellerSettlementType, isDefault: boolean, companyName?: string | null, sellerName?: string | null, bank?: Types.EBankCode | null, accountNumber?: string | null }>, addresses: Array<{ __typename?: 'SellerAddressGraphqlType', id: number, isDefault: boolean, address: string, detailAddress?: string | null, zipCode: string }> } | null, sellerSettlementInfo?: { __typename?: 'SellerSettlementInfoGraphqlType', isDefault: boolean, type: Types.ESellerSettlementType, sellerName?: string | null, companyName?: string | null, bank?: Types.EBankCode | null, accountNumber?: string | null } | null, promotionProducts: Array<{ __typename?: 'PromotionProductGraphqlType', id: number, customPromotionProductName?: string | null, originalProductId?: number | null, originalProductGroupId?: number | null, setCount: number, inHouseBuyPrice?: number | null, isFreeProvided: boolean, isPrepayment?: boolean | null, isSellerBearing?: boolean | null, isWiredBearing?: boolean | null, sellerBearingCost?: number | null, wiredBearingCost?: number | null, originalProduct?: { __typename?: 'ProductGraphqlType', name: string } | null, originalProductGroup?: { __typename?: 'ProductGroupGraphqlType', name: string } | null, promotionItems: Array<{ __typename?: 'PromotionItemGraphqlType', id: number, customPromotionItemName?: string | null, originalItem?: { __typename?: 'ItemGraphqlType', id: number, name: string } | null }> }> } };

export type AdminUpdatePromotionReleaseMutationVariables = Types.Exact<{
  adminUpdatePromotionReleaseId: Types.Scalars['Int']['input'];
  promotionReleaseData: Types.UpdatePromotionReleaseInputGraphqlType;
}>;


export type AdminUpdatePromotionReleaseMutation = { __typename?: 'Mutation', adminUpdatePromotionRelease: { __typename?: 'PromotionReleaseOutputGraphqlType', promotionRelease: { __typename?: 'PromotionReleaseGraphqlType', id: number, releaseCode: string, releaseStatus: Types.EPromotionReleaseStatus, receiverName: string, receiverPhoneNumber: string, receiverAddress: string, receiverDetailAddress?: string | null, deliveryMessage?: string | null, scheduledReleaseAt?: string | null, note?: string | null, promotion: { __typename?: 'PromotionGraphqlType', id: number, promotionType: Types.EPromotionType, sampleStatus: Types.ESampleStatus, isDeliveryFee: boolean, deliveryFee?: number | null, deliveryFeeBearer?: Types.ECostBearer | null, market?: { __typename?: 'MarketGraphqlType', id: number, name: string, productGroups: Array<{ __typename?: 'ProductGroupGraphqlType', id: number, name: string, products: Array<{ __typename?: 'ProductGraphqlType', id: number, name: string, useType: Types.EProductUseType, items?: Array<{ __typename?: 'ItemGraphqlType', id: number, name: string }> | null }> }> } | null, marketEvent?: { __typename?: 'MarketEventGraphqlType', id: number, type: Types.EMarketEventType, count?: number | null } | null }, seller?: { __typename?: 'SellerGraphqlType', id: number, name: string } | null, promotionProducts: Array<{ __typename?: 'PromotionProductGraphqlType', id: number, originalProductGroupId?: number | null, setCount: number, isFreeProvided: boolean, originalProduct?: { __typename?: 'ProductGraphqlType', id: number, name: string } | null, originalProductGroup?: { __typename?: 'ProductGroupGraphqlType', name: string } | null, promotionItems: Array<{ __typename?: 'PromotionItemGraphqlType', id: number, customPromotionItemName?: string | null, originalItem?: { __typename?: 'ItemGraphqlType', id: number, name: string } | null }> }> } } };

export type AdminCreatePromotionMutationVariables = Types.Exact<{
  promotionData: Types.CreatePromotionInputGraphqlType;
}>;


export type AdminCreatePromotionMutation = { __typename?: 'Mutation', adminCreatePromotion: { __typename?: 'PromotionOutputGraphqlType', promotion: { __typename?: 'PromotionGraphqlType', id: number } } };

export type AdminCreatePromotionEventMutationVariables = Types.Exact<{
  promotionEventData: Types.CreatePromotionEventInputGraphqlType;
}>;


export type AdminCreatePromotionEventMutation = { __typename?: 'Mutation', adminCreatePromotionEvent: { __typename?: 'PromotionOutputGraphqlType', promotion: { __typename?: 'PromotionGraphqlType', id: number } } };

export type AdminCountPromotionStatusesQueryVariables = Types.Exact<{
  promotionType: Types.ECountPromotionType;
}>;


export type AdminCountPromotionStatusesQuery = { __typename?: 'Query', adminCountPromotionStatuses: { __typename?: 'CountPromotionStatusesOutputGraphqlType', countReleaseStatuses?: Array<{ __typename?: 'CountReleaseStatusesGraphqlType', count: number, status: Types.EPromotionReleaseStatus }> | null, countSampleStatuses?: Array<{ __typename?: 'CountSampleStatusesGraphqlType', count: number, status: Types.ESampleStatus }> | null } };

export type AdminPatchSampleStatusPromotionByIdMutationVariables = Types.Exact<{
  adminPatchSampleStatusPromotionByIdId: Types.Scalars['Int']['input'];
  promotionData: Types.PatchSampleStatusPromotionInputGraphqlType;
  marketId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type AdminPatchSampleStatusPromotionByIdMutation = { __typename?: 'Mutation', adminPatchSampleStatusPromotionById: { __typename?: 'PromotionOutputGraphqlType', promotion: { __typename?: 'PromotionGraphqlType', id: number, sampleStatus: Types.ESampleStatus } } };

export type AdminDeliveryCompaniesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminDeliveryCompaniesQuery = { __typename?: 'Query', adminDeliveryCompanies: Array<{ __typename?: 'DeliveryCompanyGraphqlType', id: number, code: string, name: string, international: boolean }> };

export type AdminBulkPatchPromotionReleaseStatusMutationVariables = Types.Exact<{
  promotionReleaseData: Types.BulkPatchPromotionReleaseStatusInputGraphqlType;
}>;


export type AdminBulkPatchPromotionReleaseStatusMutation = { __typename?: 'Mutation', adminBulkPatchPromotionReleaseStatus: { __typename?: 'BulkPatchPromotionReleaseStatusOutputGraphqlType', successCaseCount: number, failCases: Array<{ __typename?: 'FailCase', reason: string, releaseCode: string }> } };

export type AdminUpdatePromotionMutationVariables = Types.Exact<{
  adminUpdatePromotionId: Types.Scalars['Int']['input'];
  originalProductGroupId: Types.Scalars['Int']['input'];
  promotionData: Types.UpdatePromotionInputGraphqlType;
}>;


export type AdminUpdatePromotionMutation = { __typename?: 'Mutation', adminUpdatePromotion: { __typename?: 'PromotionOutputGraphqlType', promotion: { __typename?: 'PromotionGraphqlType', id: number } } };

export type AdminBulkPatchPromotionReleaseDeliveryInfoMutationVariables = Types.Exact<{
  data: Array<Types.PatchPromotionReleaseDeliveryInfoInputType> | Types.PatchPromotionReleaseDeliveryInfoInputType;
}>;


export type AdminBulkPatchPromotionReleaseDeliveryInfoMutation = { __typename?: 'Mutation', adminBulkPatchPromotionReleaseDeliveryInfo: { __typename?: 'BulkPatchPromotionReleaseDeliveryInfoOutputGraphqlType', successCaseCount: number, failCases: Array<{ __typename?: 'FailCase', reason: string, releaseCode: string }> } };


export const AdminPromotionReleasesDocument = gql`
    query AdminPromotionReleases($filter: PromotionReleaseFilterQuery, $pagination: Pagination) {
  adminPromotionReleases(filter: $filter, pagination: $pagination) {
    totalCount
    edges {
      node {
        id
        promotion {
          id
          promotionType
          orderCode
          vendor {
            id
            name
          }
          isDeliveryFee
          deliveryFeeBearer
          deliveryFee
          manager {
            id
            name
          }
          market {
            id
            name
          }
          sampleStatus
        }
        updatedAt
        createdAt
        releaseStatus
        promotionProducts {
          customPromotionProductName
          promotionItems {
            id
            originalItem {
              id
              name
            }
          }
          originalProduct {
            name
          }
          originalProductGroup {
            id
            name
          }
          setCount
          isFreeProvided
          isPrepayment
          isSellerBearing
          isWiredBearing
          sellerBearingCost
          wiredBearingCost
          delivery {
            id
            trackingNumber
            deliveryCompanyId
            promotionProductId
          }
        }
        scheduledReleaseAt
        confirmedOrderAt
        completedReleaseAt
        seller {
          id
          name
        }
        note
        zipCode
        receiverName
        receiverPhoneNumber
        receiverAddress
        receiverDetailAddress
        deliveryMessage
        releaseCode
      }
    }
  }
}
    `;

/**
 * __useAdminPromotionReleasesQuery__
 *
 * To run a query within a React component, call `useAdminPromotionReleasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPromotionReleasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPromotionReleasesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAdminPromotionReleasesQuery(baseOptions?: Apollo.QueryHookOptions<AdminPromotionReleasesQuery, AdminPromotionReleasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPromotionReleasesQuery, AdminPromotionReleasesQueryVariables>(AdminPromotionReleasesDocument, options);
      }
export function useAdminPromotionReleasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPromotionReleasesQuery, AdminPromotionReleasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPromotionReleasesQuery, AdminPromotionReleasesQueryVariables>(AdminPromotionReleasesDocument, options);
        }
export type AdminPromotionReleasesQueryHookResult = ReturnType<typeof useAdminPromotionReleasesQuery>;
export type AdminPromotionReleasesLazyQueryHookResult = ReturnType<typeof useAdminPromotionReleasesLazyQuery>;
export type AdminPromotionReleasesQueryResult = Apollo.QueryResult<AdminPromotionReleasesQuery, AdminPromotionReleasesQueryVariables>;
export const AdminPromotionReleaseDocument = gql`
    query AdminPromotionRelease($adminPromotionReleaseId: Int!) {
  adminPromotionRelease(id: $adminPromotionReleaseId) {
    id
    releaseCode
    releaseStatus
    promotion {
      id
      orderCode
      promotionType
      sampleStatus
      isDeliveryFee
      deliveryFee
      deliveryFeeBearer
      deliveryFeeSettlementPrice
      deliveryFeeSettlementTarget
      market {
        id
        name
        productGroups {
          id
          name
          products {
            id
            name
            useType
            items {
              id
              name
            }
          }
        }
      }
      marketEvent {
        id
        type
        count
      }
      promotionReleases {
        id
        receiverName
        receiverPhoneNumber
        zipCode
        receiverAddress
        deliveryMessage
        releaseStatus
      }
    }
    seller {
      id
      name
      phoneNumber
      settlementInfos {
        id
        type
        isDefault
        companyName
        sellerName
        bank
        accountNumber
      }
      addresses {
        id
        isDefault
        address
        detailAddress
        zipCode
      }
    }
    sellerSettlementInfoId
    sellerSettlementInfo {
      isDefault
      type
      sellerName
      companyName
      bank
      accountNumber
    }
    zipCode
    receiverName
    receiverPhoneNumber
    receiverAddress
    receiverDetailAddress
    deliveryMessage
    promotionProducts {
      id
      customPromotionProductName
      originalProductId
      originalProduct {
        name
      }
      originalProductGroupId
      originalProductGroup {
        name
      }
      setCount
      inHouseBuyPrice
      isFreeProvided
      isPrepayment
      isSellerBearing
      isWiredBearing
      sellerBearingCost
      wiredBearingCost
      promotionItems {
        id
        customPromotionItemName
        originalItem {
          id
          name
        }
      }
    }
    scheduledReleaseAt
    note
  }
}
    `;

/**
 * __useAdminPromotionReleaseQuery__
 *
 * To run a query within a React component, call `useAdminPromotionReleaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPromotionReleaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPromotionReleaseQuery({
 *   variables: {
 *      adminPromotionReleaseId: // value for 'adminPromotionReleaseId'
 *   },
 * });
 */
export function useAdminPromotionReleaseQuery(baseOptions: Apollo.QueryHookOptions<AdminPromotionReleaseQuery, AdminPromotionReleaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminPromotionReleaseQuery, AdminPromotionReleaseQueryVariables>(AdminPromotionReleaseDocument, options);
      }
export function useAdminPromotionReleaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminPromotionReleaseQuery, AdminPromotionReleaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminPromotionReleaseQuery, AdminPromotionReleaseQueryVariables>(AdminPromotionReleaseDocument, options);
        }
export type AdminPromotionReleaseQueryHookResult = ReturnType<typeof useAdminPromotionReleaseQuery>;
export type AdminPromotionReleaseLazyQueryHookResult = ReturnType<typeof useAdminPromotionReleaseLazyQuery>;
export type AdminPromotionReleaseQueryResult = Apollo.QueryResult<AdminPromotionReleaseQuery, AdminPromotionReleaseQueryVariables>;
export const AdminUpdatePromotionReleaseDocument = gql`
    mutation AdminUpdatePromotionRelease($adminUpdatePromotionReleaseId: Int!, $promotionReleaseData: UpdatePromotionReleaseInputGraphqlType!) {
  adminUpdatePromotionRelease(
    id: $adminUpdatePromotionReleaseId
    promotionReleaseData: $promotionReleaseData
  ) {
    promotionRelease {
      id
      releaseCode
      releaseStatus
      promotion {
        id
        promotionType
        sampleStatus
        isDeliveryFee
        deliveryFee
        deliveryFeeBearer
        market {
          id
          name
          productGroups {
            id
            name
            products {
              id
              name
              useType
              items {
                id
                name
              }
            }
          }
        }
        marketEvent {
          id
          type
          count
        }
      }
      seller {
        id
        name
      }
      receiverName
      receiverPhoneNumber
      receiverAddress
      receiverDetailAddress
      deliveryMessage
      promotionProducts {
        id
        originalProduct {
          id
          name
        }
        originalProductGroupId
        originalProductGroup {
          name
        }
        setCount
        isFreeProvided
        promotionItems {
          id
          customPromotionItemName
          originalItem {
            id
            name
          }
        }
      }
      scheduledReleaseAt
      note
    }
  }
}
    `;
export type AdminUpdatePromotionReleaseMutationFn = Apollo.MutationFunction<AdminUpdatePromotionReleaseMutation, AdminUpdatePromotionReleaseMutationVariables>;

/**
 * __useAdminUpdatePromotionReleaseMutation__
 *
 * To run a mutation, you first call `useAdminUpdatePromotionReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdatePromotionReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdatePromotionReleaseMutation, { data, loading, error }] = useAdminUpdatePromotionReleaseMutation({
 *   variables: {
 *      adminUpdatePromotionReleaseId: // value for 'adminUpdatePromotionReleaseId'
 *      promotionReleaseData: // value for 'promotionReleaseData'
 *   },
 * });
 */
export function useAdminUpdatePromotionReleaseMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdatePromotionReleaseMutation, AdminUpdatePromotionReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdatePromotionReleaseMutation, AdminUpdatePromotionReleaseMutationVariables>(AdminUpdatePromotionReleaseDocument, options);
      }
export type AdminUpdatePromotionReleaseMutationHookResult = ReturnType<typeof useAdminUpdatePromotionReleaseMutation>;
export type AdminUpdatePromotionReleaseMutationResult = Apollo.MutationResult<AdminUpdatePromotionReleaseMutation>;
export type AdminUpdatePromotionReleaseMutationOptions = Apollo.BaseMutationOptions<AdminUpdatePromotionReleaseMutation, AdminUpdatePromotionReleaseMutationVariables>;
export const AdminCreatePromotionDocument = gql`
    mutation AdminCreatePromotion($promotionData: CreatePromotionInputGraphqlType!) {
  adminCreatePromotion(promotionData: $promotionData) {
    promotion {
      id
    }
  }
}
    `;
export type AdminCreatePromotionMutationFn = Apollo.MutationFunction<AdminCreatePromotionMutation, AdminCreatePromotionMutationVariables>;

/**
 * __useAdminCreatePromotionMutation__
 *
 * To run a mutation, you first call `useAdminCreatePromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreatePromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreatePromotionMutation, { data, loading, error }] = useAdminCreatePromotionMutation({
 *   variables: {
 *      promotionData: // value for 'promotionData'
 *   },
 * });
 */
export function useAdminCreatePromotionMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreatePromotionMutation, AdminCreatePromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreatePromotionMutation, AdminCreatePromotionMutationVariables>(AdminCreatePromotionDocument, options);
      }
export type AdminCreatePromotionMutationHookResult = ReturnType<typeof useAdminCreatePromotionMutation>;
export type AdminCreatePromotionMutationResult = Apollo.MutationResult<AdminCreatePromotionMutation>;
export type AdminCreatePromotionMutationOptions = Apollo.BaseMutationOptions<AdminCreatePromotionMutation, AdminCreatePromotionMutationVariables>;
export const AdminCreatePromotionEventDocument = gql`
    mutation AdminCreatePromotionEvent($promotionEventData: CreatePromotionEventInputGraphqlType!) {
  adminCreatePromotionEvent(promotionEventData: $promotionEventData) {
    promotion {
      id
    }
  }
}
    `;
export type AdminCreatePromotionEventMutationFn = Apollo.MutationFunction<AdminCreatePromotionEventMutation, AdminCreatePromotionEventMutationVariables>;

/**
 * __useAdminCreatePromotionEventMutation__
 *
 * To run a mutation, you first call `useAdminCreatePromotionEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreatePromotionEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreatePromotionEventMutation, { data, loading, error }] = useAdminCreatePromotionEventMutation({
 *   variables: {
 *      promotionEventData: // value for 'promotionEventData'
 *   },
 * });
 */
export function useAdminCreatePromotionEventMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreatePromotionEventMutation, AdminCreatePromotionEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreatePromotionEventMutation, AdminCreatePromotionEventMutationVariables>(AdminCreatePromotionEventDocument, options);
      }
export type AdminCreatePromotionEventMutationHookResult = ReturnType<typeof useAdminCreatePromotionEventMutation>;
export type AdminCreatePromotionEventMutationResult = Apollo.MutationResult<AdminCreatePromotionEventMutation>;
export type AdminCreatePromotionEventMutationOptions = Apollo.BaseMutationOptions<AdminCreatePromotionEventMutation, AdminCreatePromotionEventMutationVariables>;
export const AdminCountPromotionStatusesDocument = gql`
    query AdminCountPromotionStatuses($promotionType: ECountPromotionType!) {
  adminCountPromotionStatuses(promotionType: $promotionType) {
    countReleaseStatuses {
      count
      status
    }
    countSampleStatuses {
      count
      status
    }
  }
}
    `;

/**
 * __useAdminCountPromotionStatusesQuery__
 *
 * To run a query within a React component, call `useAdminCountPromotionStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCountPromotionStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCountPromotionStatusesQuery({
 *   variables: {
 *      promotionType: // value for 'promotionType'
 *   },
 * });
 */
export function useAdminCountPromotionStatusesQuery(baseOptions: Apollo.QueryHookOptions<AdminCountPromotionStatusesQuery, AdminCountPromotionStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCountPromotionStatusesQuery, AdminCountPromotionStatusesQueryVariables>(AdminCountPromotionStatusesDocument, options);
      }
export function useAdminCountPromotionStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCountPromotionStatusesQuery, AdminCountPromotionStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCountPromotionStatusesQuery, AdminCountPromotionStatusesQueryVariables>(AdminCountPromotionStatusesDocument, options);
        }
export type AdminCountPromotionStatusesQueryHookResult = ReturnType<typeof useAdminCountPromotionStatusesQuery>;
export type AdminCountPromotionStatusesLazyQueryHookResult = ReturnType<typeof useAdminCountPromotionStatusesLazyQuery>;
export type AdminCountPromotionStatusesQueryResult = Apollo.QueryResult<AdminCountPromotionStatusesQuery, AdminCountPromotionStatusesQueryVariables>;
export const AdminPatchSampleStatusPromotionByIdDocument = gql`
    mutation AdminPatchSampleStatusPromotionById($adminPatchSampleStatusPromotionByIdId: Int!, $promotionData: PatchSampleStatusPromotionInputGraphqlType!, $marketId: Int) {
  adminPatchSampleStatusPromotionById(
    id: $adminPatchSampleStatusPromotionByIdId
    promotionData: $promotionData
    marketId: $marketId
  ) {
    promotion {
      id
      sampleStatus
    }
  }
}
    `;
export type AdminPatchSampleStatusPromotionByIdMutationFn = Apollo.MutationFunction<AdminPatchSampleStatusPromotionByIdMutation, AdminPatchSampleStatusPromotionByIdMutationVariables>;

/**
 * __useAdminPatchSampleStatusPromotionByIdMutation__
 *
 * To run a mutation, you first call `useAdminPatchSampleStatusPromotionByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminPatchSampleStatusPromotionByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminPatchSampleStatusPromotionByIdMutation, { data, loading, error }] = useAdminPatchSampleStatusPromotionByIdMutation({
 *   variables: {
 *      adminPatchSampleStatusPromotionByIdId: // value for 'adminPatchSampleStatusPromotionByIdId'
 *      promotionData: // value for 'promotionData'
 *      marketId: // value for 'marketId'
 *   },
 * });
 */
export function useAdminPatchSampleStatusPromotionByIdMutation(baseOptions?: Apollo.MutationHookOptions<AdminPatchSampleStatusPromotionByIdMutation, AdminPatchSampleStatusPromotionByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminPatchSampleStatusPromotionByIdMutation, AdminPatchSampleStatusPromotionByIdMutationVariables>(AdminPatchSampleStatusPromotionByIdDocument, options);
      }
export type AdminPatchSampleStatusPromotionByIdMutationHookResult = ReturnType<typeof useAdminPatchSampleStatusPromotionByIdMutation>;
export type AdminPatchSampleStatusPromotionByIdMutationResult = Apollo.MutationResult<AdminPatchSampleStatusPromotionByIdMutation>;
export type AdminPatchSampleStatusPromotionByIdMutationOptions = Apollo.BaseMutationOptions<AdminPatchSampleStatusPromotionByIdMutation, AdminPatchSampleStatusPromotionByIdMutationVariables>;
export const AdminDeliveryCompaniesDocument = gql`
    query AdminDeliveryCompanies {
  adminDeliveryCompanies {
    id
    code
    name
    international
  }
}
    `;

/**
 * __useAdminDeliveryCompaniesQuery__
 *
 * To run a query within a React component, call `useAdminDeliveryCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminDeliveryCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminDeliveryCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminDeliveryCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<AdminDeliveryCompaniesQuery, AdminDeliveryCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminDeliveryCompaniesQuery, AdminDeliveryCompaniesQueryVariables>(AdminDeliveryCompaniesDocument, options);
      }
export function useAdminDeliveryCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminDeliveryCompaniesQuery, AdminDeliveryCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminDeliveryCompaniesQuery, AdminDeliveryCompaniesQueryVariables>(AdminDeliveryCompaniesDocument, options);
        }
export type AdminDeliveryCompaniesQueryHookResult = ReturnType<typeof useAdminDeliveryCompaniesQuery>;
export type AdminDeliveryCompaniesLazyQueryHookResult = ReturnType<typeof useAdminDeliveryCompaniesLazyQuery>;
export type AdminDeliveryCompaniesQueryResult = Apollo.QueryResult<AdminDeliveryCompaniesQuery, AdminDeliveryCompaniesQueryVariables>;
export const AdminBulkPatchPromotionReleaseStatusDocument = gql`
    mutation AdminBulkPatchPromotionReleaseStatus($promotionReleaseData: BulkPatchPromotionReleaseStatusInputGraphqlType!) {
  adminBulkPatchPromotionReleaseStatus(
    promotionReleaseData: $promotionReleaseData
  ) {
    successCaseCount
    failCases {
      reason
      releaseCode
    }
  }
}
    `;
export type AdminBulkPatchPromotionReleaseStatusMutationFn = Apollo.MutationFunction<AdminBulkPatchPromotionReleaseStatusMutation, AdminBulkPatchPromotionReleaseStatusMutationVariables>;

/**
 * __useAdminBulkPatchPromotionReleaseStatusMutation__
 *
 * To run a mutation, you first call `useAdminBulkPatchPromotionReleaseStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBulkPatchPromotionReleaseStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBulkPatchPromotionReleaseStatusMutation, { data, loading, error }] = useAdminBulkPatchPromotionReleaseStatusMutation({
 *   variables: {
 *      promotionReleaseData: // value for 'promotionReleaseData'
 *   },
 * });
 */
export function useAdminBulkPatchPromotionReleaseStatusMutation(baseOptions?: Apollo.MutationHookOptions<AdminBulkPatchPromotionReleaseStatusMutation, AdminBulkPatchPromotionReleaseStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBulkPatchPromotionReleaseStatusMutation, AdminBulkPatchPromotionReleaseStatusMutationVariables>(AdminBulkPatchPromotionReleaseStatusDocument, options);
      }
export type AdminBulkPatchPromotionReleaseStatusMutationHookResult = ReturnType<typeof useAdminBulkPatchPromotionReleaseStatusMutation>;
export type AdminBulkPatchPromotionReleaseStatusMutationResult = Apollo.MutationResult<AdminBulkPatchPromotionReleaseStatusMutation>;
export type AdminBulkPatchPromotionReleaseStatusMutationOptions = Apollo.BaseMutationOptions<AdminBulkPatchPromotionReleaseStatusMutation, AdminBulkPatchPromotionReleaseStatusMutationVariables>;
export const AdminUpdatePromotionDocument = gql`
    mutation AdminUpdatePromotion($adminUpdatePromotionId: Int!, $originalProductGroupId: Int!, $promotionData: UpdatePromotionInputGraphqlType!) {
  adminUpdatePromotion(
    id: $adminUpdatePromotionId
    originalProductGroupId: $originalProductGroupId
    promotionData: $promotionData
  ) {
    promotion {
      id
    }
  }
}
    `;
export type AdminUpdatePromotionMutationFn = Apollo.MutationFunction<AdminUpdatePromotionMutation, AdminUpdatePromotionMutationVariables>;

/**
 * __useAdminUpdatePromotionMutation__
 *
 * To run a mutation, you first call `useAdminUpdatePromotionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdatePromotionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdatePromotionMutation, { data, loading, error }] = useAdminUpdatePromotionMutation({
 *   variables: {
 *      adminUpdatePromotionId: // value for 'adminUpdatePromotionId'
 *      originalProductGroupId: // value for 'originalProductGroupId'
 *      promotionData: // value for 'promotionData'
 *   },
 * });
 */
export function useAdminUpdatePromotionMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdatePromotionMutation, AdminUpdatePromotionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdatePromotionMutation, AdminUpdatePromotionMutationVariables>(AdminUpdatePromotionDocument, options);
      }
export type AdminUpdatePromotionMutationHookResult = ReturnType<typeof useAdminUpdatePromotionMutation>;
export type AdminUpdatePromotionMutationResult = Apollo.MutationResult<AdminUpdatePromotionMutation>;
export type AdminUpdatePromotionMutationOptions = Apollo.BaseMutationOptions<AdminUpdatePromotionMutation, AdminUpdatePromotionMutationVariables>;
export const AdminBulkPatchPromotionReleaseDeliveryInfoDocument = gql`
    mutation AdminBulkPatchPromotionReleaseDeliveryInfo($data: [PatchPromotionReleaseDeliveryInfoInputType!]!) {
  adminBulkPatchPromotionReleaseDeliveryInfo(data: $data) {
    failCases {
      reason
      releaseCode
    }
    successCaseCount
  }
}
    `;
export type AdminBulkPatchPromotionReleaseDeliveryInfoMutationFn = Apollo.MutationFunction<AdminBulkPatchPromotionReleaseDeliveryInfoMutation, AdminBulkPatchPromotionReleaseDeliveryInfoMutationVariables>;

/**
 * __useAdminBulkPatchPromotionReleaseDeliveryInfoMutation__
 *
 * To run a mutation, you first call `useAdminBulkPatchPromotionReleaseDeliveryInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminBulkPatchPromotionReleaseDeliveryInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminBulkPatchPromotionReleaseDeliveryInfoMutation, { data, loading, error }] = useAdminBulkPatchPromotionReleaseDeliveryInfoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminBulkPatchPromotionReleaseDeliveryInfoMutation(baseOptions?: Apollo.MutationHookOptions<AdminBulkPatchPromotionReleaseDeliveryInfoMutation, AdminBulkPatchPromotionReleaseDeliveryInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminBulkPatchPromotionReleaseDeliveryInfoMutation, AdminBulkPatchPromotionReleaseDeliveryInfoMutationVariables>(AdminBulkPatchPromotionReleaseDeliveryInfoDocument, options);
      }
export type AdminBulkPatchPromotionReleaseDeliveryInfoMutationHookResult = ReturnType<typeof useAdminBulkPatchPromotionReleaseDeliveryInfoMutation>;
export type AdminBulkPatchPromotionReleaseDeliveryInfoMutationResult = Apollo.MutationResult<AdminBulkPatchPromotionReleaseDeliveryInfoMutation>;
export type AdminBulkPatchPromotionReleaseDeliveryInfoMutationOptions = Apollo.BaseMutationOptions<AdminBulkPatchPromotionReleaseDeliveryInfoMutation, AdminBulkPatchPromotionReleaseDeliveryInfoMutationVariables>;